import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { wfsBaseUrl,cfpBaseUrl } from '../../network/urls';

const initialState = {
    data: [],
    isLoading: false,
    error: null,
};

// Define an async thunk for fetching paginated data
export const fetchFeederStatus = createAsyncThunk(
    'complaints/fetchFeederStatusArray',
    async (feederString, { getState }) => {
        const { auth } = getState();
        const { wmsPrivateToken, code,token} = auth;
        const companyCode = code.slice(0, 2) + "000"



        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");
        
        const raw = JSON.stringify({
          "code": [`${feederString}`],
          "disco_code": companyCode == "10000" ? "15000" : companyCode
        });
        
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };
        const response = await  fetch(cfpBaseUrl + "UserInfo/GetFeederStatus", requestOptions)
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Feeder Status API issue!');
        }
        const result = await response.json();
        if (!result) {
            throw new Error(result.message || 'Unable to fetch stats!');
        }

        const uniqueFeedersArray = Array.from(
            result[0].response.data.reduce((acc, feeder) => {
                acc.set(feeder.feeder_code, feeder);
                return acc;
            }, new Map()).values()
        );

        return uniqueFeedersArray;
    }
);

const feederStatusSlice = createSlice({
    name: 'feederStatus',
    initialState: initialState,
    reducers: {
        resetFeederStatusState(state) {
            state.data = [];
            state.isLoading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchFeederStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchFeederStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload || [];
                state.error = null;
            })
            .addCase(fetchFeederStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetFeederStatusState } = feederStatusSlice.actions;

export default feederStatusSlice.reducer;
